import { Api } from '@/api/api';
import { Order } from '@/models/order';
import { OrderFilters } from '@/models/order-filters';
import { PagedOrderResult } from '@/models/paged-order-result';
import { OrderHistory } from '@/models/order-history';

export class OrderApi extends Api {
    public async fetchAsync(filters: OrderFilters): Promise<PagedOrderResult> {
        return await this.getAsync<PagedOrderResult>('v2/order', filters);
    }
    public async fetchByIdAsync(id: string): Promise<Order> {
        return await this.getAsync<Order>('v2/order/' + id);
    }
    public async fetchHistoryByIdAsync(id: string): Promise<Array<OrderHistory>> {
        return await this.getAsync<Array<OrderHistory>>(`v2/order/${id}/history`);
    }
    public async createAsync(order: Order): Promise<string> {
        const location = await this.postAsync<string>(`v2/order`, order);
        const id = location.replace(this.buildUrl('v2/order/'), '');
        return id;
    }
    public async receiveAsync(id: string): Promise<void> {
        await this.putAsync(`v2/order/${id}`, { status: 0 });
    }
    public async deliverAsync(id: string): Promise<void> {
        await this.putAsync(`v2/order/${id}`, { status: 1 });
    }
}
